module.exports = new __parcel__URL__("GT-Pantheon_animation-fig-1-PS-003.1eb79e72.json").toString();